/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cus_Modal_TitleInputs */

const en_cus_modal_title = /** @type {(inputs: Cus_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visit unsuccessful (Just Go)`)
};

const ja_cus_modal_title = /** @type {(inputs: Cus_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訪問不成功 (Just Go)`)
};

const fr_cus_modal_title = /** @type {(inputs: Cus_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visite infructueuse (Just Go)`)
};

const de_cus_modal_title = /** @type {(inputs: Cus_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergeblicher Besuch (Just Go)`)
};

/**
* | output |
* | --- |
* | "Visit unsuccessful (Just Go)" |
*
* @param {Cus_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cus_modal_title = /** @type {((inputs?: Cus_Modal_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cus_Modal_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cus_modal_title(inputs)
	if (locale === "ja") return ja_cus_modal_title(inputs)
	if (locale === "fr") return fr_cus_modal_title(inputs)
	return de_cus_modal_title(inputs)
});